import React, { Component } from 'react'
import { withMediaProps } from 'react-media-player'
import * as colors from '../colors'
import {style} from 'glamor'

class Progress extends Component {

  shouldComponentUpdate({ media }) {
    return this.props.media.currentTime !== media.currentTime
  }

  render() {
    const {  media } = this.props
    return (
      <div
        {...style({
          width: '100%',
          height: '3px',
          position: 'relative',
          background: colors.black10
        })}
      >
        <div
          {...style({
            position: 'absolute',
            top: 0,
            left: 0,
            background: colors.yellow,
            transformOrigin: '0 0',
            transition: 'transform 0.05s ease-out',
            transform: `scaleX(${media.currentTime / media.duration})`,
            width: '100%',
            height: '100%'
          })}
        />
      </div>
    )
  }
}

export default withMediaProps(Progress)



/** WEBPACK FOOTER **
 ** ./src/components/Progress.js
 **/